import React from 'react'
import PropTypes from 'prop-types'

const ContentNodeTextInput = (props) => {
  const { text, placeholder, onChange, setRef } = props
  return (
    <div className="contentNodeTextInput">
      <input
        type="text"
        value={text}
        placeholder={placeholder}
        spellCheck="false"
        onChange={(event) => {
          onChange(event.currentTarget.value)
        }}
        ref={(input) => {
          setRef(input)
        }}
      />
    </div>
  )
}

ContentNodeTextInput.propTypes = {
  text: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  setRef: PropTypes.func,
}

export default ContentNodeTextInput
